import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from 'app/services/loader.service';
import { PortfolioService } from '../portfolio/portfolio.service';
declare var $:any;

@Component({
  selector: "app-add-apartment",
  templateUrl: "./add-apartment.component.html",
  styleUrls: ["./add-apartment.component.css"],
  providers: [PortfolioService],
})
export class AddApartmentComponent implements OnInit {
  public createApartmentForm: FormGroup;
  public updateApartmentForm: FormGroup;
  city_list: any;
  states: any;
  apartments: any;
  currentPage: any;
  itemsPerPage: any;
  current_page: any;
  ApartmentName: any;
  Cluster: any;
  ApartmentAddess: any;
  PinCode: any;
  SearchForState: any;
  SearchForCity: any;
  UNID: any;
  AreaName: any;
  Lifestage: any;
  Theme: any;
  DeveloperName: any;
  StartFrom: any;
  ApartmentValue: any;
  ApartmentArea: any;
  BOQEMI: any;
  SelectFormat: any;
  VariantID: any;
  SelectLayoutFloorPlan: any;
  SelectPrimaryImage: any;
  VRLink: any;

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private portfolioService: PortfolioService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.loadStyles()
    this.updateApartmentForm = this.formBuilder.group({
      pincode: new FormControl(""),
      area_name: new FormControl(""),
      city: new FormControl(""),
      state: new FormControl(""),
      cluster: new FormControl(""),
      apartment_name: new FormControl(""),
      unid: new FormControl(""),
      apartment_address: new FormControl(""),
      developer_name: new FormControl(""),
      area: new FormControl(""),
      apartment_value: new FormControl(""),
      lifestage: new FormControl(""),
      theme: new FormControl(""),
      start_from: new FormControl(""),
      boq_emi: new FormControl(""),
      formats: this.formBuilder.array([]),
    });

    this.getStates();
    this.getFilterData();
    this.getApartmentFormatData();
    this.getap("");
    this.current_page = 1;
  }

  createItemup(): FormGroup {
    return this.formBuilder.group({
      name: new FormControl("", [Validators.required]),
      id:new FormControl(""),
      variants: this.formBuilder.array([this.createVariantItemup()]),
    });
  }

  createVariantItemup(): FormGroup {
    return this.formBuilder.group({
      variant_id: new FormControl("", [Validators.required]),
      layout_image: new FormControl("", [Validators.required]),
      primary_image: new FormControl("", [Validators.required]),
      vr_link: new FormControl(""),
      id:new FormControl(""),
      layout_imgagefilename:new FormControl(""),
      primary_imagefilename:new FormControl("")
    });
  }

  pushJobAttributesup(updateApartmentForm) {
    return updateApartmentForm.get("formats").push(this.createItemup());
  }

  addAnotherVariant(item) {
    var sec_arr = this.updateApartmentForm.get("formats") as FormArray;
    item.get("variants").push(
      this.formBuilder.group({
        variant_id: new FormControl("", [Validators.required]),
        layout_image: new FormControl("", [Validators.required]),
        primary_image: new FormControl("", [Validators.required]),
        vr_link: new FormControl(""),
        id: new FormControl(""),
        layout_imgagefilename:new FormControl(""),
        primary_imagefilename:new FormControl("")
      })
    );
  }

  back() {
    this.router.navigate(["/list-apartment"]);
  }

  getStates() {
    this.portfolioService.getStateList().subscribe((res) => {
      this.states = res.state_list;
    });
  }
  headers_res;
  per_page;
  total_page;

  getap(e) {
    e = e?e:"";
    this.current_page = e;
    this.loaderService.display(true);
    this.portfolioService.getallapartments(this.current_page,this.searchstring).subscribe((res) => {
      this.headers_res = res.headers._headers;
      this.per_page = this.headers_res.get('x-per-page');
      this.total_page = this.headers_res.get('x-total');
      this.current_page = this.headers_res.get('x-page');
      res = res.json();
      this.apartments = res.data;
      this.loaderService.display(false);
    });
  }

  confirmAndDelete(data: any) {
    if (confirm("Are You Sure to Delete this Apartment") == true) {
      this.portfolioService.deleteapartment(data).subscribe((res) => {
        this.getap(this.current_page);
      });
    }
  }

  getscityList(id) {
    this.portfolioService.getApartmentCity(id).subscribe((res) => {
      this.city_list = res.Cities[id];
    });
  }
  onSubmit2(data) {
    console.log(data);

    this.loaderService.display(true);
    window.scrollTo(0, 0);
 
    this.portfolioService.editPortapartment(data).subscribe(
      (res) => {
       

        this.portfolioService.Deletevarients(this.VarientsToDelete).subscribe(res=>{

          this.successMessageShow("Apartment Updated Successfully")
          console.log(res);
          $("#exampleModalLong2").modal("hide");
          this.getap('');
          this.loaderService.display(false);

        },err=>{
          this.errorMessageShow(JSON.parse(err['_body']).message);
          this.loaderService.display(false);

        })
        



       

        
      },
      (err) => {
        this.errorMessage = "";
        this.msgError = true;
        this.loaderService.display(false);
      }
    );
  }

  theme: any;
  lifeStage: any;
  getFilterData() {
    this.portfolioService.getFilterData().subscribe((res) => {
      this.lifeStage = res.lifestage;
      this.theme = res.theme;
    });
  }

  formatData: any;
  getApartmentFormatData() {
    this.portfolioService.getFormatData().subscribe((res) => {
      this.formatData = res.format;
    });
  }
  VarientsToDelete=[];
  Deletevariants(e,item,i,j) {
    let id;
    console.log(this.variantids, e);
    id = this.variantids.filter((el) => {
      return e == el.id;
    });
    console.log(id);
    if(id.length > 0){
      id = id[0].id;
      this.VarientsToDelete.push(id);
      console.log(this.VarientsToDelete);
     this.successMessageShow("Selected Varient is Selected to Delete it will Delete When u Submit form")    
    } 
    else{
      item.get('variants').removeAt(j)

    }
  }

  Unselect(id){
    let index ;
    index = this.VarientsToDelete.indexOf(id);
    this.VarientsToDelete.splice(index,1);

  }

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }
  apartment_details: any;
  dynamicformats: any;
  dynamicVarients: any;
  variantids = [];

  FormatIDs:any =[];
  VarientsIdForCheck = [];

  getapartment(id: number) {
    this.layoutimg1 = [];
        this.layoutimg2 = [];
        this.layoutimg3 = [];
        this.layoutimg4 = [];
        this.primaryimg1 =[];
        this.primaryimg2 =[];
        this.primaryimg3 =[];
        this.primaryimg4 =[];
        this.variantids =[];
        this.FormatIDs =[];
        this.VarientsToDelete  = [];
        this.VarientsIdForCheck =[];

    
    this.portfolioService.viewapartmentData(id).subscribe((res) => {
      this.apartment_details = res;
      (<FormArray>this.updateApartmentForm.controls["formats"]).controls = [];

      this.updateApartmentForm.controls["apartment_name"].setValue(
        this.apartment_details.apartment_name
      );
      this.updateApartmentForm.controls["cluster"].setValue(
        this.apartment_details.cluster
      );
      this.updateApartmentForm.controls["apartment_address"].setValue(
        this.apartment_details.apartment_address
      );
      this.updateApartmentForm.controls["pincode"].setValue(
        this.apartment_details.pincode
      );
      this.updateApartmentForm.controls["area_name"].setValue(
        this.apartment_details.area_name
      );
      this.updateApartmentForm.controls["developer_name"].setValue(
        this.apartment_details.developer_name
      );
      this.updateApartmentForm.controls["start_from"].setValue(
        this.apartment_details.start_from
      );
      this.updateApartmentForm.controls["apartment_value"].setValue(
        this.apartment_details.apartment_value
      );
      this.updateApartmentForm.controls["boq_emi"].setValue(
        this.apartment_details.boq_emi
      );
      this.updateApartmentForm.controls["unid"].setValue(
        this.apartment_details.unid
      );
      this.updateApartmentForm.controls["area"].setValue(
        this.apartment_details.area
      );
      this.updateApartmentForm.controls["city"].setValue(
        this.apartment_details.city
      );
      this.updateApartmentForm.controls["state"].setValue(
        this.apartment_details.state
      );
      this.updateApartmentForm.controls["lifestage"].setValue(
        this.apartment_details.lifestage
      );
      this.updateApartmentForm.controls["theme"].setValue(
        this.apartment_details.theme
      );
      // this.updateApartmentForm.controls['formats'].setValue(this.apartment_details.formats);
      var sec_arr = this.updateApartmentForm.get("formats") as FormArray;

      for (var i = 0; i < this.apartment_details.formats.length; i++) {

        this.FormatIDs.push(this.apartment_details.formats[i][0].id)

        sec_arr.push(
          this.formBuilder.group({
            name: new FormControl(
              this.apartment_details.formats[i][0].format_name,
              [Validators.required]
            ),
            id: new FormControl(
              this.apartment_details.formats[i][0].id,
              [Validators.required]),
            variants:  this.formBuilder.array([]),
          })
        );

        var varients = sec_arr.controls[i]["controls"]["variants"] as FormArray;
        (<FormArray>varients).controls = [];
        for (var j = 0; j < this.apartment_details.formats[i].length; j++) {
          console.log(this.apartment_details.formats[i].length);
          this.variantids.push({
            id: this.apartment_details.formats[i][j].id,
            VariantID: this.apartment_details.formats[i][j].variant_id,
          });
          this.VarientsIdForCheck.push(this.apartment_details.formats[i][j].id)

          varients.push(
            this.formBuilder.group({
              variant_id: new FormControl(
                this.apartment_details.formats[i][j].variant_id,
                [Validators.required]
              ),
              layout_image: new FormControl(
                this.apartment_details.formats[i][j].layout_image,
                [Validators.required]
              ),
              primary_image: new FormControl(
                this.apartment_details.formats[i][j].primary_image,
                [Validators.required]
              ),
              vr_link: new FormControl(
                this.apartment_details.formats[i][j].vr_link
              ),
              id:new FormControl(
                this.apartment_details.formats[i][j].id),
                layout_imgagefilename: new FormControl(
                 ""
                ),
                primary_imagefilename: new FormControl(
                 ""
                ),
            }),
            
          );

          console.log(sec_arr);
        }
      }
    });
  }

  attachment_file: any;
  basefile = [];
  basefile3 = [];
  layoutimg1 = [];
  layoutimg2 = [];
  layoutimg3 = [];
  layoutimg4 = [];
  onChange(event, i, j) {
    this.attachment_file = event.srcElement.files[0];
    (<HTMLInputElement>document.getElementById(`fileNamePresettwoupdate${i}${j}`)).value = this.attachment_file.name
    // if((this.attachment_file.size/1024) > 120) {
    //   document.getElementById('errorsize'+i).innerHTML = 'File size should not exceed 120kb.';
    // }
    console.log(this.attachment_file)
   
    var sec_arr = this.updateApartmentForm.get("formats") as FormArray;
    sec_arr.controls[i]["controls"]["variants"].controls[j].controls['layout_imgagefilename'].patchValue(this.attachment_file.name)


    var fileReader = new FileReader();

    
    fileReader.onload = (fileLoadedEvent) => {
      var base64;
      var image = new Image();
      image.src = fileReader.result;
      base64 = fileLoadedEvent.target;
      console.log("guijjj",base64.result)
      this.basefile2 = base64.result
      this.layoutimg1.push(base64.result);
      sec_arr.controls[i]["controls"]["variants"].controls[j].controls['layout_image'].patchValue(base64.result)
    };

 

    console.log(this.layoutimg1)
    

    

  

    console.log(sec_arr);
    console.log(sec_arr.controls[i]["controls"]["variants"].controls[j].controls['layout_image'].value)

    fileReader.readAsDataURL(this.attachment_file);
  }

  attachment_file2: any;
  basefile2 = [];
  basefile4 = [];
  primaryimg1 = [];
  primaryimg2 = [];
  primaryimg3 = [];
  primaryimg4 = [];
  onChangeImage(event, i, j) {
    this.attachment_file2 = event.srcElement.files[0];
    console.log(this.attachment_file2);
    (<HTMLInputElement>document.getElementById(`fileNamePresetoneupdate${i}${j}`)).value = this.attachment_file2.name
    var sec_arr = this.updateApartmentForm.get("formats") as FormArray;
    sec_arr.controls[i]["controls"]["variants"].controls[j].controls['primary_imagefilename'].patchValue(this.attachment_file2.name)
    var fileReader = new FileReader();

      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile2 = base64.result
        this.primaryimg1.push(base64.result);
        sec_arr.controls[i]["controls"]["variants"].controls[j].controls['primary_image'].patchValue(base64.result)
      };

   

   
    fileReader.readAsDataURL(this.attachment_file2);
    
    console.log(sec_arr);
  }

  transform(value: string): string {
    return value.replace(/_/g, " ");
  }
  erroralert: any;
  errorMessage: any;
  successalert;
  successMessage;
  errorMessageShow(msg) {
    this.erroralert = true;
    this.errorMessage = msg;
    setTimeout(
      function () {
        this.erroralert = false;
      }.bind(this),
      2000
    );
  }
  successMessageShow(msg) {
    this.successalert = true;
    this.successMessage = msg;
    setTimeout(
      function () {
        this.successalert = false;
      }.bind(this),
      2000
    );
  }

  msgError: boolean = false;
  
  successError: boolean = false;

  searchstring:any="";

  RemoveValidator(i){
    var sec_arr = this.updateApartmentForm.get("formats") as FormArray;
    let value =  sec_arr.controls[i]["controls"]["id"].value;

    if(this.FormatIDs.indexOf(value) == -1){
     sec_arr.removeAt(i)

    } else{
      this.loaderService.display(true)
      this.portfolioService.DeleteFormat(sec_arr.controls[i]["controls"]["name"].value,this.updateApartmentForm.controls['unid'].value).subscribe(res=>{
        this.successMessageShow("Format Deleted Successfully");
        sec_arr.removeAt(i);
        this.loaderService.display(false);



      },err=>{

        this.loaderService.display(false);

        this.errorMessageShow(JSON.parse(err['_body']).message)

      })

    }
  


  }

  showValidator(i){
    var sec_arr = this.updateApartmentForm.get("formats") as FormArray;
    let value =  sec_arr.controls[i]["controls"]["id"].value;

    if(this.FormatIDs.indexOf(value) == -1){
     return "show"

    } else{
      return "hide"

    }
  }


  
  closemodal(){
   
    $("#exampleModalLong2").modal("hide");
  }

  loadStyles(){
    
    let node7 = document.createElement('link');
   node7.href = 'https://fonts.gstatic.com';
   node7.rel ="preconnect"
   document.getElementsByTagName('head')[0].appendChild(node7);
   let node8 = document.createElement('link');
   node8.href = 'https://fonts.googleapis.com/css2?family=Arimo:wght@300&display=swap';
   node8.rel ="stylesheet"
   document.getElementsByTagName('head')[0].appendChild(node8);
   console.log("sucess")
  }
  
 
}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/add-apartment.component.ts